import axios from "axios";
import {ENGINE_TC_TYPE} from "@/services/ConstantService";
import {GlobalService} from "@/services/GlobalService";
import {UrlService} from "@/services/UrlService";

export const EngineTcTypeService = {
  async getEngineTcTypes(params) {
    return await axios.get(ENGINE_TC_TYPE + UrlService.setQueryString(params)).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET ENGINE TC TYPE LIST SERVICE')
      return false
    })
  },
  async createEngineTcType(params) {
    return await axios.post(ENGINE_TC_TYPE,params).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'CREATE ENGINE TC TYPE SERVICE')
      return error?.response?.data
    })
  },

  async updateEngineTcType(params) {
    return await axios.put(ENGINE_TC_TYPE + `/${params.id}`,params).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'UPDATE ENGINE TC TYPE SERVICE')
      return error?.response?.data ?? false
    })
  },

  async deleteEngineTcType(params) {
    return await axios.delete(ENGINE_TC_TYPE + `/${params.id}`).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'DELETE ENGINE TC TYPE SERVICE')
      return false
    })
  },
}
